// extracted by mini-css-extract-plugin
module.exports = {"coral":"_1YpRavJLKl-button-theme-coral-coral","shadowed":"IhFOqbyDot-button-theme-coral-shadowed"};